import * as React from "react"
import injectSheet from "react-jss"
import products, { getProduct } from "@/helpers/products"
import { Card, Icon } from "@xingternal/360-components"
import { Box } from "@xingternal/winery-ui/lib/Box"
import { ErrorView, KpiPanelHeader } from "@/components"
import styled from "styled-components"
import { useIsRebrandingEnabled } from "@xingternal/rebranding-adapter"

const ProductIconCircleStyled = styled(Box)`
  background: ${({ product, enableXingRebranding }) =>
    products[product] && getProduct(product, enableXingRebranding).color};
`

const styles = {
  container: { composes: "p12" },
  productIconCircle: {
    composes:
      "inline-flex justify-center items-center circle relative white mr8",
    marginLeft: -6,
    width: 30,
    height: 30,
  },
}

const KpiPanel = ({
  children,
  classes,
  error,
  icon,
  isUpdating,
  title,
  fenced,
  openLightbox,
  product,
  showAvailableProductNotice,
}) => {
  const { enableXingRebranding } = useIsRebrandingEnabled()

  return (
    <div className={classes.container}>
      <Card>
        <KpiPanelHeader
          isUpdating={isUpdating}
          isFailed={!!error}
          fenced={fenced}
          openLightbox={openLightbox}
          product={product}
          showAvailableProductNotice={showAvailableProductNotice}
        >
          {icon && (
            <ProductIconCircleStyled
              className={classes.productIconCircle}
              data-testid="kpi-panel-icon"
              product={product}
              enableXingRebranding={enableXingRebranding}
            >
              <Icon name={icon} />
            </ProductIconCircleStyled>
          )}
          {title}
        </KpiPanelHeader>
        {error ? (
          <ErrorView
            actionText={error.actionText}
            action={error.action}
            className={error.className}
            isActionable={isUpdating}
            message={error.message}
          />
        ) : (
          children
        )}
      </Card>
    </div>
  )
}

export const StyledKpiPanel = injectSheet(styles)(KpiPanel)
export default KpiPanel
